<template>
  <div>
    <el-breadcrumb separator="/" style="margin-bottom: 20px;">
      <el-breadcrumb-item el-breadcrumb-item :to="{ path: '/personal/batch' }">个人奖申报批次</el-breadcrumb-item>
      <el-breadcrumb-item el-breadcrumb-item :to="{ path: '/personal?batchId=' +  $route.query.batchId }">个人奖申报</el-breadcrumb-item>
      <el-breadcrumb-item>{{ id ? '编辑申报' : '添加申报'}}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-form :model="addForm" v-loading="loadings" :rules="ruleAddForm" ref="addForm" label-position="top" label-width="120px" class="demo-ruleForms">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="奖项类别" prop="categoryId">
              <el-select size="small" v-model="addForm.categoryId" placeholder="请选择" style="width: 100%;" clearable @change="selectChange($event)">
                <el-option :label="item.category" :value="item.id" v-for="(item, index) in categoryList" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="姓名" prop="name">
              <el-input size="small" maxlength="50" show-word-limit v-model="addForm.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="年龄" prop="age">
              <el-input size="small" maxlength="50" show-word-limit type="number" v-model="addForm.age" placeholder="请输入年龄"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="性别" prop="sex">
              <el-select size="small" v-model="addForm.sex" placeholder="请选择" style="width: 100%;" clearable>
                <el-option label="男" value="1" ></el-option>
                <el-option label="女" value="2" ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="邮箱" prop="email">
              <el-input size="small" maxlength="50" show-word-limit v-model="addForm.email" placeholder="请输入邮箱"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="职称" prop="title">
              <el-input size="small" maxlength="50" show-word-limit v-model="addForm.title" placeholder="请输入职称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="单位" prop="unit">
              <el-input size="small" maxlength="50" show-word-limit v-model="addForm.unit" placeholder="请输入单位"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工作年限" prop="workYears">
              <el-input size="small" maxlength="50" show-word-limit type="number" v-model="addForm.workYears" placeholder="请输入工作年限"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系方式" prop="personalPhone">
              <el-input size="small" maxlength="11" show-word-limit type="number" v-model="addForm.personalPhone" placeholder="请输入手机号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 最高获奖项目 -->
        <el-form-item label="最高获奖项目" required>
        </el-form-item>
        <div style="display: flex; margin-bottom: 10px;" >
          <div style="width: 200px;">名称</div>
          <div style="width: 200px; margin-left: 10px;">个人排名</div>
          <div style="width: 200px; margin-left: 10px;">取得时间</div>
          <div style="width: 200px; margin-left: 10px;">授予单位</div>
        </div>
        <div style="display: flex; margin-bottom: 10px;">
          <el-form-item style="width: 200px;" prop="awardName">
            <el-input size="small" maxlength="50" show-word-limit style="width: 100%;" placeholder="请输入项目名称" v-model="addForm.awardName"></el-input>
          </el-form-item>
          <el-form-item label="" prop="personalRank" style="width: 200px; margin-left: 10px">
            <el-input size="small" maxlength="50" show-word-limit type="number" style="width: 100%%;" placeholder="请输入个人排名" v-model="addForm.personalRank"></el-input>
          </el-form-item>
          <el-form-item label="" prop="obtainYears" style="width: 200px; margin-left: 10px">
            <el-date-picker size="small" style="width: 100%;" v-model="addForm.obtainYears" type="month" value-format="yyyy-MM" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="" prop="grantUnit" style="width: 200px; margin-left: 10px">
            <el-input size="small" maxlength="50" show-word-limit style="width: 100%;" placeholder="请输入授予单位" v-model="addForm.grantUnit"></el-input>
          </el-form-item>
        </div>
        <!-- 其他获奖项目（最多9个） -->
        <el-form-item label="其他获奖项目（最多9个）">
        </el-form-item>
        <div v-if="addForm.arr1 && addForm.arr1.length > 0">
          <div style="display: flex; margin-bottom: 10px;" >
            <div style="width: 200px;">名称</div>
            <div style="width: 200px; margin-left: 10px;">取得时间</div>
          </div>
          <div style="display: flex; margin-bottom: 10px;" v-for="(item, index) in addForm.arr1" :key="index">
            <el-form-item style="width: 200px;" :prop="'arr1.' + index + '.awardName'" :rules="{ required: true, message: '请输入项目名称', trigger: 'blur' }">
              <el-input size="small" maxlength="50" show-word-limit placeholder="请输入项目名称" v-model="item.awardName"></el-input>
            </el-form-item>
            <el-form-item style="width: 200px; margin-left: 10px;" :prop="'arr1.' + index + '.winningYear'" :rules="{ required: true, message: '请选择日期', trigger: 'change' }">
              <el-date-picker size="small" style="width: 100%;" v-model="item.winningYear" type="month" value-format="yyyy-MM" placeholder="选择日期"></el-date-picker>
            </el-form-item>
            <el-button size="small" style="margin-left: 10px; height: 32px;" type="danger" @click="del('arr1', index)">删除</el-button>
          </div>
        </div>
        <el-form-item >
          <el-button size="small" type="primary" icon="el-icon-plus" @click="add('arr1')">添加</el-button>
        </el-form-item>
        <!--  -->
        <el-form-item label="获得最高奖励" required>
        </el-form-item>
        <div style="display: flex; margin-bottom: 10px;" >
          <div style="width: 200px;">名称</div>
          <div style="width: 200px; margin-left: 10px;">授予单位</div>
        </div>
        <div style="display: flex; margin-bottom: 10px;">
          <el-form-item prop="highestAwardName" style="width: 200px;">
            <el-input size="small" maxlength="50" show-word-limit style="width: 100%;" placeholder="请输入最高荣誉名称" v-model="addForm.highestAwardName"></el-input>
          </el-form-item>
          <el-form-item prop="highestGrantUnit" style="width: 200px; margin-left: 10px">
            <el-input size="small" maxlength="50" show-word-limit style="width: 100%;" placeholder="请输入授予单位" v-model="addForm.highestGrantUnit"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="其他奖励（最多9个）">
        </el-form-item>
        <div v-if="addForm.arr2 && addForm.arr2.length > 0">
          <div style="display: flex; margin-bottom: 10px;" >
            <div style="width: 200px;">名称</div>
          </div>
          <div style="display: flex; margin-bottom: 10px;" v-for="(item, index) in addForm.arr2" :key="index">
            <el-form-item style="width: 200px;" :prop="'arr2.' + index + '.awardName'" :rules="{ required: true, message: '请输入荣誉名称', trigger: 'blur' }">
              <el-input size="small" maxlength="50" show-word-limit style="width: 100%;" placeholder="请输入荣誉名称" v-model="item.awardName"></el-input>
            </el-form-item>
            <el-button size="small" style="margin-left: 10px; height: 32px;" type="danger" @click="del('arr2', index)">删除</el-button>
          </div>
        </div>
        <el-form-item >
          <el-button size="small" type="primary" icon="el-icon-plus" @click="add('arr2')">添加</el-button>
        </el-form-item>
        <!-- 推荐专家 -->
        <el-form-item label="推荐专家" required>
        </el-form-item>
        <div style="display: flex; margin-bottom: 10px;" >
          <div style="width: 200px;">专家名称</div>
          <div style="width: 200px; margin-left: 10px;">工作单位</div>
          <div style="width: 200px; margin-left: 10px;">职务</div>
          <div style="width: 200px; margin-left: 10px;">职称</div>
        </div>
        <div style="display: flex; margin-bottom: 10px;" v-for="(item, index) in addForm.personlExperts" :key="index">
          <el-form-item style="width: 200px;" :prop="'personlExperts.' + index + '.name'" :rules="{ required: true, message: '请输入专家名称', trigger: 'blur' }">
            <el-input size="small" maxlength="50" show-word-limit style="width: 100%;" placeholder="请输入专家名称" v-model="item.name"></el-input>
          </el-form-item>
          <el-form-item style="width: 200px; margin-left: 10px;" :prop="'personlExperts.' + index + '.unit'" :rules="{ required: true, message: '请输入专家单位名称', trigger: 'blur' }">
            <el-input size="small" maxlength="50" show-word-limit style="width: 100%;" placeholder="请输入专家单位名称" v-model="item.unit"></el-input>
          </el-form-item>
          <el-form-item style="width: 200px; margin-left: 10px;" :prop="'personlExperts.' + index + '.position'" :rules="{ required: true, message: '请输入专家职位', trigger: 'blur' }">
            <el-input size="small" maxlength="50" show-word-limit style="width: 100%;" placeholder="请输入专家职位" v-model="item.position"></el-input>
          </el-form-item>
          <el-form-item style="width: 200px; margin-left: 10px;" :prop="'personlExperts.' + index + '.title'" :rules="{ required: true, message: '请输入专家职称', trigger: 'blur' }">
            <el-input size="small" maxlength="50" show-word-limit style="width: 100%;" placeholder="请输入专家职称" v-model="item.title"></el-input>
          </el-form-item>
        </div>
        <!-- word -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="请提交申报书（限doc/docx格式文件 100MB）" prop="declareWordPath" class="db-lable-b">
              <el-checkbox-group v-model="addForm.declareWordPath" v-show="false"></el-checkbox-group>
              <My-Upload-Filebutton :limit="1" :size="100" :accept="'.doc,.docx'" @UploadFileFun="UploadFileFun($event, 'declareWordPath')" :callbackShow="addForm.declareWordFile"></My-Upload-Filebutton>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="请上传证明材料（限pdf格式文件 100MB）" prop="provePath" class="db-lable-b">
              <el-checkbox-group v-model="addForm.provePath" v-show="false"></el-checkbox-group>
              <My-Upload-Filebutton :limit="1" :size="100" :accept="'.pdf'" @UploadFileFun="UploadFileFun($event, 'provePath')" :callbackShow="addForm.proveFile"></My-Upload-Filebutton>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="请上传申报资料（pdf格式文件）" prop="declarePdfPath" class="db-lable-b">
              <el-checkbox-group v-model="addForm.declarePdfPath" v-show="false"></el-checkbox-group>
              <My-Upload-Filebutton :limit="1" :accept="'.pdf'" @UploadFileFun="UploadFileFun($event, 'declarePdfPath')" :callbackShow="addForm.declarePdfFile"></My-Upload-Filebutton>
            </el-form-item>
          </el-col>
        </el-row> -->
        <div style="text-align: center; margin-top: 50px;" v-if="status == 1 && (personalState == 1 || isDraft != 2)">
          <el-button type="primary" @click="submitDraft" :loading="loadingDraft" v-if="addForm.acceptExamineStatus != 5">保存草稿</el-button>
          <el-button type="primary" @click="submit" :loading="loading">提 交</el-button>
        </div>
        <!--  -->
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { increasedPersonalAddDraft } from '@/api/increased'
import { getCategoryList, addAwardPersonal, getAwardPersonals, getProjectAwardBatchList, getMangerStatus } from '@/api/admin'
import MyUploadFilebutton from '@/components/uploadFilebutton/UploadFilebutton'
export default {
  components: { MyUploadFilebutton },
  data () {
    return {
      isDraft: '',
      personalState: '', // 添加状态
      status: '',
      id: '',
      loadings: false,
      categoryList: [],
      addLoaing: false,
      loading: false,
      addForm: {
        opinion: '',
        categoryId: '',
        noPrefix: '',
        name: '',
        age: '',
        sex: '',
        email: '',
        title: '',
        unit: '',
        workYears: '',
        awardName: '',
        personalRank: '',
        obtainYears: '',
        grantUnit: '',
        arr1: [],
        highestAwardName: '',
        highestGrantUnit: '',
        arr2: [],
        declareWordPath: '',
        provePath: '',
        declarePdfPath: '',
        personlExperts: [
          { sort: 1, name: '', unit: '', position: '', title: '' },
          { sort: 2, name: '', unit: '', position: '', title: '' },
          { sort: 3, name: '', unit: '', position: '', title: '' }
        ],
        personalPhone: ''
      },
      ruleAddForm: {
        categoryId: [{ required: true, message: '请选择项目类别', trigger: 'change' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        age: [{ required: true, message: '请输入年龄', trigger: 'blur' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        personalPhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '手机号格式错误', trigger: ['blur', 'change'] }
        ],
        title: [{ required: true, message: '请输入职称', trigger: 'blur' }],
        unit: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        workYears: [{ required: true, message: '请输入工作年限', trigger: 'blur' }],
        awardName: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
        personalRank: [{ required: true, message: '请输入个人排名', trigger: 'blur' }],
        obtainYears: [{ required: true, message: '请选择日期', trigger: 'change' }],
        grantUnit: [{ required: true, message: '请输入授予单位', trigger: 'blur' }],
        highestAwardName: [{ required: true, message: '请输入最高荣誉名称', trigger: 'blur' }],
        highestGrantUnit: [{ required: true, message: '请输入授予单位', trigger: 'blur' }],
        declareWordPath: [{ required: true, message: '请上传文件', trigger: 'change' }],
        declarePdfPath: [{ required: true, message: '请上传文件', trigger: 'change' }],
        provePath: [{ required: true, message: '请上传文件', trigger: 'change' }]
      },
      loadingDraft: false
    }
  },
  created() {
    if (!this.$route.query.batchId) {
      this.$router.push({ path: '/personal/batch' })
      return false
    }
    getProjectAwardBatchList({ page: 1, pageSize: 500 }).then(res => {
      if (res.code == '000') {
        const batchIds = res.result.records
        const exists = batchIds.some(item => item.id === this.$route.query.batchId)
        if (!exists) {
          this.$router.push({ path: '/personal/batch' })
        } else {
          batchIds.forEach(item => {
            if (item.id == this.$route.query.batchId) {
              this.status = item.status
            }
          })
        }
      }
    })
    this.loadings = true
    getCategoryList({ id: '1' }).then(res => {
      this.loadings = false
      if (res.code === '000') {
        this.categoryList = res.result
      }
      if (this.$route.query.id) {
        this.id = this.$route.query.id
        this.dtl()
      }
    })
    this.getStatus()
  },
  methods: {
    submitDraft() {
      const copy1 = JSON.parse(JSON.stringify(this.addForm))
      copy1.obtainYears = copy1.obtainYears ? copy1.obtainYears + '-01' : ''
      copy1.otherAwardNumber = [...copy1.arr1, ...copy1.arr2]
      copy1.otherAwardNumber.forEach((item, index) => {
        item.sort = index
        if (item.winningYear) {
          item.winningYear = item.winningYear + '-01'
        }
      })
      copy1.id = this.id
      this.loadingDraft = true
      increasedPersonalAddDraft(copy1).then(res => {
        this.loadingDraft = false
        if (res.code === '000') {
          this.$message.success('保存成功')
          if (!this.id) {
            this.id = res.result.id
            this.$router.push({ path: '/personal/add1', query: { id: res.result.id, batchId: this.$route.query.batchId } })
          }
        }
      })
    },
    submit() {
      this.$refs.addForm.validate(valid => {
        if (!valid) return this.$message.error('您还有必填项没有填写，请填写完成后再提交')
        this.$confirm('是否确定提交申报?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const copy1 = JSON.parse(JSON.stringify(this.addForm))
          copy1.obtainYears = copy1.obtainYears + '-01'
          copy1.otherAwardNumber = [...copy1.arr1, ...copy1.arr2]
          copy1.otherAwardNumber.forEach((item, index) => {
            item.sort = index
            if (item.winningYear) {
              item.winningYear = item.winningYear + '-01'
            }
          })
          copy1.id = this.id
          this.loading = true
          addAwardPersonal(copy1).then(res => {
            this.loading = false
            if (res.code === '000') {
              this.$message.success('操作成功')
              setTimeout(() => {
                this.$router.push({ path: '/personal', query: { batchId: this.$route.query.batchId } })
              }, 500)
            }
          })
        })
      })
    },
    del (type, index) {
      this.addForm[type].splice(index, 1)
    },
    add (type) {
      if (this.addForm[type].length > 8) return this.$message.warning('最多添加9个')
      switch (type) {
        case 'arr1':
          this.addForm[type].push({ awardName: '', type: '1', winningYear: '' })
          break
        case 'arr2':
          this.addForm[type].push({ awardName: '', type: '2' })
          break
      }
    },
    UploadFileFun(e, type) {
      this.addForm[type] = e
    },
    dtl () {
      this.loadings = true
      getAwardPersonals({ id: this.id }).then(res => {
        this.loadings = false
        if (res.code === '000') {
          this.isDraft = res.result.isDraft
          res.result.declareWordPath = ''
          res.result.provePath = ''
          res.result.arr1 = []
          res.result.arr2 = []
          res.result.otherAwardNumber.forEach(item => {
            if (item.type == 1) {
              res.result.arr1.push(item)
            }
            if (item.type == 2) {
              res.result.arr2.push(item)
            }
          })
          this.addForm = res.result
          this.addForm.obtainYears = res.result.obtainYears || ''
        }
      })
    },
    selectChange(e) {
      if (e) {
        this.categoryList.forEach(item => {
          if (item.id == e) {
            this.addForm.noPrefix = item.noPrefix
          }
        })
      }
    },
    getStatus() {
      return getMangerStatus().then(res => {
        if (res.code == '000') {
          this.personalState = res.result.personalState
        }
      })
    }
  }
}
</script>

<style lang="less" >
  .el-form--label-top .el-form-item__content {
    line-height: 32px;
  }
  .el-form--label-top .el-form-item__label {
    padding: 0;
    line-height: 32px;
  }
  .el-form--label-top .el-form-item {
    margin-bottom: 14px;
  }
</style>

<style lang="less" scoped>
.demo-ruleForm .el-form-item {
  margin-bottom: 10px;
}
</style>
